module.exports =  {

  whyTokenNotFound: {
    title: '为什么在创建新挂单的选项中找不到我要的代币？',
    contents: `
      <p>创建新订单时，您可以从下拉列表中选择用于购入和卖出的代币，这个列表中的选项包括您已关注的代币以及
      一些热门代币。如果选项中没有您想要的代币，您可以返回“我的代币”页面来添加这个代币。如有需要卖出该代币，
      您还需要先添加对于该代币的交易授权。</p>
      <p>LedgerDex支持所有ERC20代币之间的交易，用户可以自行添加任意交易对，”上币“不需要通过我们的允许。</p>
    `,
  },

  whyTokenNotSelectableForSelling: {
    title: '为什么卖出代币选项中有的代币无法选择？',
    contents: `
    	<p>当您选择一个卖出代币时，并不是选项中的所有代币都可以选择。只有当您拥有该代币（余额大于0）并且已经添加对于该代币的交易授权时您才可以选择这种代币作为卖出代币。</p>
    `,
  },

}

